import { Helmet } from 'react-helmet-async';

export const SITE_NAME = 'InfoMotores';
export const DEFAULT_TITLE = 'InfoMotores — Compra, Venda e Aluguer de Carros, Motas, Barcos e Máquinas em Angola';
export const DEFAULT_DESCRIPTION = 'Compre, venda ou alugue carros, motas, barcos, máquinas, peças e serviços em Angola. Milhares de anúncios verificados na InfoMotores.';
export const DEFAULT_IMAGE = (typeof window !== 'undefined' ? window.location.origin : '') + '/external_assets/img/motor_logo.png';

// Renders per-page <title>, meta description, canonical link, Open Graph
// and Twitter Card tags (and optional JSON-LD) via react-helmet-async, so
// every route gets its own SEO tags instead of the one static index.html title.
const SEO = ({ title, description, image, path, type = 'website', jsonLd, noindex }) => {
    const pageTitle = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const ogImage = image || DEFAULT_IMAGE;
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const canonical = origin + (path || (typeof window !== 'undefined' ? window.location.pathname : ''));

    return (
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={canonical} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:url" content={canonical} />
            <meta property="og:locale" content="pt_AO" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={ogImage} />

            {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
        </Helmet>
    );
};

export default SEO;
